import React from 'react';
import autoBind from 'react-autobind';
import { Marker } from 'react-google-maps';

class MapEditPoint extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      open: this.props.open
    };
  }

  handleMarkerLocationChange({ latLng }) {
    const { lng, lat } = latLng;
    this.props.onMarkerLocationChange([lng(), lat()]);
  }

  render() {
    const { center } = this.props;
    const position = { lat: center[1], lng: center[0] };
    return (
      <Marker
        onDragEnd={this.handleMarkerLocationChange}
        position={position}
        draggable
      />
    );
  }
}

export default MapEditPoint;



// WEBPACK FOOTER //
// ./src/pages/Facility/MapEditPoint/index.jsx